import { render, staticRenderFns } from "./WorkspaceTraitSigChainEvidence.vue?vue&type=template&id=c0513cda&scoped=true"
import script from "./WorkspaceTraitSigChainEvidence.vue?vue&type=script&lang=js"
export * from "./WorkspaceTraitSigChainEvidence.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceTraitSigChainEvidence.vue?vue&type=style&index=0&id=c0513cda&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0513cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0513cda')) {
      api.createRecord('c0513cda', component.options)
    } else {
      api.reload('c0513cda', component.options)
    }
    module.hot.accept("./WorkspaceTraitSigChainEvidence.vue?vue&type=template&id=c0513cda&scoped=true", function () {
      api.rerender('c0513cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceTraitSigChainEvidence.vue"
export default component.exports